import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getContactsQueryOptions } from '@/_pages/contacts/api-service';

export const Route = createFileRoute('/_private/contacts/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
